import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    avatarPlaceholder: {
        justifyContent: "center"
    },
    container: {
        alignItems: "center"
    },
    presidentLabelContainer: {
        width: 80
    },
    textCenter: {
        textAlign: "center"
    }
});
export default stylesheet;
